<template>
    <v-card v-if="!item.empty" class="dashboard-item">
        <v-card-text>
            <div class="dashboard-item__name">{{$t(item.t)}}</div>
            <v-divider></v-divider>
            <div class="dashboard-item__val">{{item.val}}</div>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "DashboardItem",
        props: ['item']
    }
</script>
